import { useFirebaseToken } from '@/hooks/useFirebaseUser/useFirebaseToken'

import { useThreadsServiceGetV1IndividualsByIndividualIdThreadsByThreadId } from '../client/queries'

export const useThread = (threadId?: string, individualId?: string) => {
  const token = useFirebaseToken()

  return useThreadsServiceGetV1IndividualsByIndividualIdThreadsByThreadId(
    { individualId: individualId!, threadId: threadId! },
    undefined,
    {
      enabled: !!individualId && !!token && !!threadId,
      staleTime: 0,
    },
  )
}
